<template>
    <div class="vfb-field vfb-field--check" :class="classes.wrapper">
        <div class="vfb-field__container" :class="classes.container">
            <input
                class="vfb-check-input"
                :id="id"
                :name="name"
                v-model="model"
                :value="value"
                :type="type"
                :class="classes.input"
                :disabled="disabled"
                :required="required"
                :aria-describedby="helpText ? id + '-help-block' : undefined"
                @input="handleInput"
            />
            <FormLabel
                v-if="label"
                :id="id"
                :label="label"
                :required="required"
                :className="classes.label"
            />
            <HelpText
                v-if="helpText && helpText.length > 0"
                :id="id + '-help-block'"
                :helpText="helpText"
                :className="classes.help"
            />
            <FormErrors class="vfb-errors" :class="classes.errors" />
        </div>

    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import FormLabel from './Label.ce.vue';
import FormErrors from './Errors.ce.vue';
import HelpText from './includes/HelpText.ce.vue';

interface Classes {
    wrapper?: string;
    container?: string;
    input?: string;
    label?: string;
    help?: string;
    errors?: string;
}

const props = defineProps({
    id: {
        type: String,
        required: true,
    },
    required: {
        type: Boolean,
        default: false,
    },
    type: {
        type: String,
        default: 'checkbox',
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    label: {
        type: String,
        required: true,
    },
    modelValue: {
        type: [String, Boolean],
        required: true,
    },
    name: {
        type: String,
        required: true,
    },
    value: {
        type: [String, Boolean],
        required: true,
    },
    helpText: {
        type: String,
        default: '',
    },
    classes: {
        type: Object as () => Classes,
        default: () => ({
            wrapper: '',
            container: 'form-check',
            input: 'form-check-input',
            label: 'form-check-label',
            help: 'form-help',
            errors: '',
        }),
    },
});

const emit = defineEmits<{
    (event: 'update:modelValue', value: string | boolean): void;
    (event: 'update:checked', value: boolean): void;
}>();

const model = computed({
    get() {
        return props.modelValue;
    },
    set(value: string | boolean) {
        emit('update:modelValue', value);
    },
});

const handleInput = (event: Event) => {
    const target = event.target as HTMLInputElement;
    emit('update:checked', target.checked);
};
</script>